<template>
  <footer class="footer px-container py-component">
    <div class="footer-links">
      <a href="#">Ads</a>
      <a href="#">Cookies</a>
      <a href="#">Privacy Policy</a>
    </div>
<!--    <div class="footer-copyright hide-on-mobile">-->
<!--      🌐 NiceApp-->
<!--    </div>-->
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer {
  border-top: 1px solid var(--my-border);
  background-color: var(--my-semi-dark);
  z-index: 1000;
  color: #b0b0b5;
  text-align: center;
  margin-top: -41px;
  display: flex;
  justify-content: center;
  align-items: center;

}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  flex-wrap: wrap;
  gap: var(--space-inner);
  font-weight: 300;
}

.footer-links a {
  color: #b0b0b5;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #ffffff;
}

.footer-copyright {
  font-size: 14px;
  color: #b0b0b5;
}

@media (max-width: 768px) {
  .footer {
    padding-bottom: calc(var(--space-outer) + 73px); /* 63px для нижнего меню */
  }
}
</style>
